export default function numericalSort(a, b) {
  return a - b;
}
